import { Box, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay, Flex, IconButton, Link, createIcon, useBreakpointValue, useDisclosure } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import React from 'react';
import SideNav from '../side-navigation/side-navigation-app';
import TopNavigationLogo from './top-navigation-logo';
import TopNavigationUserMenu from './user-menu/top-navigation-user-menu';

export default function TopNavigationApp(props) {
    const { user, company, accessHelper, application, analyze, authorization, zendeskWidget, translations, urlLookup } = props;
    const { useEffect, useRef } = React;
    const { isOpen, onOpen, onClose } = useDisclosure();
    const iconBtnRef = useRef(null);


    const breakpoint = useBreakpointValue({ base: 'base', lg: 'lg' });

    useEffect(() => {
        if (breakpoint === 'lg') {
        onClose();
        }
    }, [breakpoint]);

    const Close = createIcon({
        displayName: 'Close',
        viewBox: '0 0 24 24',
        d: 'M24 2.49724L14.4972 12L24 21.5028L21.5028 24L12 14.4972L2.49724 24L0 21.5028L9.50276 12L0 2.49724L2.49724 0L12 9.50276L21.5028 0L24 2.49724Z',
      });

    const Hamburger = createIcon({
        displayName: 'Hamburger',
        viewBox: '0 0 26 20',
        path: [
          <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 18.1429H25M1 9.57143H25M1 1H25"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>,
        ],
      });


    
    return (
        
            <Flex
      data-testid="main-nav"
      height="80px"
      alignItems="center"
      justifyContent="space-between"
      paddingX={4}
      borderBottom="1px"
      borderBottomColor="gray.100"
      backgroundColor="white"
      width="full"
      position="fixed"
      zIndex={100}
      id="mainNav"
    >
        <IconButton
        size="md"
        icon={isOpen ? <Close /> : <Hamburger />}
        aria-label="Open Menu"
        display={{ lg: 'none' }}
        onClick={isOpen ? onClose : onOpen}
        backgroundColor="transparent"
        color="blackAlpha.800"
        _hover={{
          backgroundColor: 'transparent',
          color: 'brand.primary',
        }}
        _active={{
          backgroundColor: 'transparent',
          color: 'brand.primary',
        }}
        ref={iconBtnRef}
      />

        <Link href="/explore">
          <TopNavigationLogo variant="explore" application={application} />
        </Link>

        <TopNavigationUserMenu translations={translations} user={user} company={company} accessHelper={accessHelper} application={application} analyze={analyze} authorization={authorization} zendeskWidget={zendeskWidget} />

        <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={iconBtnRef}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          <DrawerBody padding={0}>
            
              <SideNav initialOpen forceRender={true} user={user} company={company} accessHelper={accessHelper} application={application} urlLookup={urlLookup} />
            
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
        
    
    )
}